export const BID_STATUSES = ['PENDING', 'ACCEPTED', 'REJECTED'];

export const BID_UNITS = ['TOTAL', 'WDC', 'PERCENT', 'KWH', 'YEAR'];

/** Same labels/values as deals search (ProjectFilters) revenue type filter */
export const BID_REVENUE_TYPE_OPTIONS = [
  { key: 'ci', text: 'Commercial & Industrial', value: 'CI' },
  { key: 'community-solar', text: 'Community Solar', value: 'COMMUNITY_SOLAR' },
  { key: 'utility', text: 'Utility', value: 'UTILITY' },
];

export const SORT_COLUMNS = {
  AMOUNT: 'amount',
  CREATED_AT: 'createdAt',
  IRR: 'calculatedIrr'
};
